/**
 * Standalone web entry. Identical to the Electron renderer entry by design —
 * the only thing that differs between the two builds is which backend
 * `createPlatform()` finds at runtime.
 *
 * The one exception is the stylesheet: `./styles.css` re-exports the shared
 * renderer tokens and adds the `@source` Tailwind needs when the Vite root is
 * `web/` rather than `src/renderer/`. See the comment in that file.
 */

import './styles.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/App'
import { AppProvider } from '@/store/app-store'
import { createPlatform } from '@/store/platform'

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root element')

const platform = await createPlatform()

createRoot(container).render(
  <StrictMode>
    <AppProvider platform={platform}>
      <App />
    </AppProvider>
  </StrictMode>,
)
